<template>
	<div>
		<v-tabs v-model="activeTab" background-color="transparent" centered color="secondary" slider-color="secondary">
			<v-tab :value="0" v-show="checkPermission('AppSettings_TotalSettingsTab')">تنظیمات کلی</v-tab>
			<v-tab :value="1" v-show="checkPermission('AppSettings_FinancialTab')">تنظیمات مالی</v-tab>
			<!-- <v-tab :key="2">تنظیمات آیس</v-tab> -->
			<v-tab :value="2" v-show="checkPermission('AppSettings_IranValidityTab')">اعتبارسنجی ایران</v-tab>
			<v-tab :value="3" v-show="checkPermission('AppSettings_RefahBetaTab') && checkActivePart('refahBeta')">بتا بانک رفاه</v-tab>
			<v-tab :value="4" v-show="checkPermission('AppSettings_EmzameTab') && checkActivePart('emzame')">تنظیمات امضامی</v-tab>
			<v-tab :value="5" v-show="checkPermission('AppSettings_LandingPageTab')">صفحه اختصاصی شما</v-tab>

			<v-tabs-items v-model="activeTab" touchless>
				<v-tab-item :value="0" v-show="checkPermission('AppSettings_TotalSettingsTab')">
					<v-form ref="overallForm" class="mx-2" lazy-validation>
						<v-card class="px-3 py-5 mb-3" style="background-color: #f1f1f1;">
							<div class="primary--text"><strong>نحوه رند کردن:</strong></div>
							<div>
								<span>تعداد</span>
								<v-select v-model="localData.roundCountNumber" dense style="display: inline-block;width: 90px;margin-left:5px;margin-right:5px;text-align:center" required :items="roundCountNumber" label="" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								<span>رقم آخر مبلغ قسط رند شود و کسری</span>
								<v-select v-model="localData.appendToWhichInstallment" dense style="display: inline-block;width: 200px;margin-left:5px;margin-right:5px" class="text-center" required :items="appendToWhichInstallmentItems" label="" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
							</div>
							<div class="primary--text mt-3 mb-4"><strong>آیتم های فعال داشبورد را مشخص کنید:</strong>
							</div>
							<v-row>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.stats" style="display:inline" :label="'آمار سیستم'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.overDueInstallments" style="display:inline" :label="'اقساط سررسید شده'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.pendingPaymentRequests" style="display:inline" :label="'اعلام واریزهای جدید'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.loanRequests" style="display:inline" :label="'درخواست وام ها'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.smsCredit" style="display:inline" :label="'اعتبار پیامک'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.agentOverdue" style="display:inline" :label="'سررسید سهم نماینده'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.contactOverdue" style="display:inline" :label="'سررسید سهم طرف حساب ها'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.sponsoreDueDate" style="display:inline" :label="'سررسید اسپانسرها'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.depositChargeDueDate" style="display:inline" :label="'سررسید واریز به مشتری'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.onlineTransactions" style="display:inline" :label="'واریز قسط های آنلاین'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.bankTransactions" style="display:inline" :label="'تراکنش های بانک'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.cashTransactions" style="display:inline" :label="'تراکنش های صندوق'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.goldTransactions" style="display:inline" :label="'جعبه شکن'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0" v-if="checkActivePart('ticket')">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.ticket" style="display:inline" :label="'تیکت ها'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0" v-if="checkActivePart('customerOrders')">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.customerOrders" style="display:inline" :label="'سفارش خرید ها'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0" v-if="checkActivePart('agentFactorGateway')">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.agentFactorGateway" style="display:inline" :label="'صورتحساب الکترونیکی نماینده ها'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0" v-if="checkActivePart('memberAuthorization')">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.memberAuthorization" style="display:inline" :label="'احراز هویت ها'" />
								</v-col>
								<v-col cols="12" md="4" class="py-0" v-if="checkActivePart('digitalSign')">
									<v-checkbox color="secondary" v-model="localData.dashboardSettings.digitalSignContracts" style="display:inline" :label="'آخرین امضا دیجیتال ها'" />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<div class="primary--text mb-4"><strong>تنظیمات:</strong></div>
									<div>
										<v-checkbox color="secondary" v-model="localData.memberCanChangeProfile" style="display:inline" :label="'مشتری بتواند پروفایل خود را ویرایش کند.'" />
									</div>
									<div>
										<v-checkbox color="secondary" v-model="localData.isMemberRegistrationDisabled" style="display:inline" :label="'قابلیت ثبت نام مشتری غیر فعال باشد.'" />
									</div>
									<div>
										<v-checkbox color="secondary" v-model="localData.otpRequiredInManualMemberRegistration" style="display:inline" :label="'کد تائیدیه پیامکی، زمان ثبت دستی مشتری در پنل ادمین اجباری باشد.'" />
									</div>
									<div>
										<v-checkbox color="secondary" v-model="localData.showSubmitFirstLoanRequestNotifInMemberPanel" style="display:inline" :label="'پیغام ثبت درخواست وام به مشتریانی که تاکنون درخواست نداشته اند در پنل مشتری نمایش داده شود.'" />
									</div>
									<div>
										<v-checkbox color="secondary" v-model="localData.preventCreateLoanNonCurrentDate" style="display:inline" :label="'عدم اجازه ثبت تاریخ شروع پرونده در تاریخ غیر جاری.'" />
									</div>
									<div class="d-flex align-center">
										<span>در صورتیکه چند درصد از قسط واریز شده باشد، جریمه اعمال نشود و زودکرد اعمال شود:</span>
										<v-text-field compact v-model="localData.percentOfConsideringAsPaid" type="number" style="max-width: 75px" class="center-input mx-2" label="" :error-messages="errorMessages" />
										<small class="grey--text">درصد</small>
									</div>
								</v-col>
							</v-row>
						</v-card>
					</v-form>
				</v-tab-item>
				<v-tab-item :value="1" v-if="checkPermission('AppSettings_FinancialTab')">
					<v-form ref="financeForm" class="mx-2" lazy-validation>
						<v-card class="px-3 py-5 mb-3" style="background-color: #f1f1f1;">
							<v-row>
								<v-col cols="12" md="12">
									<v-switch v-model="localData.isOnlinePaymentActive" label="پرداخت آنلاین فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
								</v-col>
							</v-row>
							<v-card class="px-3 mt-3">
								<v-row>
									<v-col cols="12" class="p-3" v-if="localData.isOnlinePaymentActive">
										<v-select v-model="localData.onlinePaymentGateway" :items="onlinePaymentGateways" item-text="title" item-value="id" label="درگاه بانکی پیش فرض" outlined class="pt-3" :error-messages="errorMessages" />
										<div v-if="localData.onlinePaymentGateway === 1">
											<div class="text-h6 grey--text text-right">در این روش پس از ثبت نام در سایت
												زرین پال، مراحل تاییدیه
												را طی نموده و مرچنت کد از درگاه پرداخت زرین پال را دریافت نمایید و در
												این بخش وارد کنید. </div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 1" outlined ref="merchantId" v-model="localData.zarinpalMerchantCode" class="left-input pt-3" label="مرچنت کد" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
													<a href="https://www.aparat.com/v/cgAwb" target="_blank">نحوه دریافت
														مرچنت کد</a>
												</v-col>
											</v-row>
										</div>
										<div v-if="localData.onlinePaymentGateway === 3">
											<div class="text-h6 grey--text text-right ">در این روش مشتری به درگاه
												بانکی اختصاصی شما در بانک
												سامان هدایت شده و پرداخت را مستقیما به حساب شما واریز میکند. که
												طبیعتا نیازمند به طی کردن پروسه
												دریافت درگاه آنلاین و در نهایت دریافت شماره ترمینال از بانک سامان می
												باشید </div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 3" outlined ref="sepTerminalId" v-model="localData.sepTerminalId" class="left-input pt-3" label="شماره ترمینال" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
													<a href="https://sep.ir/%D8%B1%D8%A7%D9%87%D9%86%D9%85%D8%A7-%D9%88-%D9%85%D8%B3%D8%AA%D9%86%D8%AF%D8%A7%D8%AA-%D9%81%D9%86%DB%8C" target="_blank">نحوه دریافت درگاه بانک سامان</a>
												</v-col>
											</v-row>
										</div>
										<div v-if="localData.onlinePaymentGateway === 4">
											<div class="text-h6 grey--text text-right ">در این روش پس از ثبت نام در
												سایت نکست پی، مراحل
												تاییدیه را طی نموده و کلید مجوز رابط از درگاه پرداخت نکست پی را
												دریافت نمایید و در این بخش وارد
												کنید.</div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 4" outlined ref="nextPayApiKey" v-model="localData.nextPayApiKey" class="left-input pt-3" label="کلید مجوز رابط" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
													<a href="https://nextpay.org/" target="_blank">هدایت به سایت
														نِکست پی</a>
												</v-col>
											</v-row>
										</div>
										<div v-if="localData.onlinePaymentGateway === 5">
											<div class="text-h6 grey--text text-right ">در این روش مشتری به درگاه
												بانکی اختصاصی شما در بانک
												پارسیان هدایت شده و پرداخت را مستقیما به حساب شما واریز میکند. که
												طبیعتا نیازمند به طی کردن
												پروسه دریافت درگاه آنلاین و در نهایت دریافت نام کاربری از بانک
												پارسیان می باشید </div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 5" outlined ref="ipgLoginAccount" v-model="localData.ipgParsianLoginAccount" class="left-input pt-3" label="لاگین اکانت" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
												</v-col>
											</v-row>
										</div>
										<div v-if="localData.onlinePaymentGateway === 6">
											<div class="text-h6 grey--text text-right ">در این روش مشتری به درگاه
												بانکی اختصاصی شما در بانک
												ملی هدایت شده و پرداخت را مستقیما به حساب شما واریز میکند. که طبیعتا
												نیازمند به طی کردن
												پروسه دریافت درگاه آنلاین و در نهایت دریافت نام کاربری از بانک ملی
												می باشید </div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 6" outlined ref="sadadTerminalId" v-model="localData.sadadTerminalId" class="left-input pt-3" label="شماره ترمینال" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
													<a href="https://sadadpsp.ir/fa/ipg-dargah-pardakht" target="_blank">نحوه دریافت درگاه بانک سداد</a>
												</v-col>
												<v-col cols="12" md="9" class="pt-0">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 6" outlined v-model="localData.sadadMerchantId" class="left-input pt-0" label="شماره پذیرنده" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="9" class="pt-0">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 6" outlined v-model="localData.sadadMerchantKey" class="left-input pt-0" label="کلید پذیرنده (ترمینال)" :error-messages="errorMessages" />
												</v-col>
											</v-row>
										</div>
										<div v-if="localData.onlinePaymentGateway === 7">
											<div class="text-h6 grey--text text-right ">در این روش مشتری به درگاه
												بانکی اختصاصی شما در بانک
												صادرات هدایت شده و پرداخت را مستقیما به حساب شما واریز میکند. که
												طبیعتا نیازمند به طی کردن
												پروسه دریافت درگاه آنلاین و در نهایت دریافت نام کاربری از بانک
												صادرات می باشید </div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 7" outlined ref="sepehrTerminalId" v-model="localData.sepehrTerminalId" class="left-input pt-3" label="شماره ترمینال" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
												</v-col>
											</v-row>
										</div>
										<div v-if="localData.onlinePaymentGateway === 2">
											<div class="text-h6 grey--text text-right">مشتری قسط را در درگاه پرداخت
												ما واریز می کند سپس وجه
												واریز شده پس از کسر کارمزد به حساب شبای شما پایا می شود. </div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 2" outlined ref="shaba" v-model="localData.shaba" class="left-input pt-3" placeholder="IR" label="شماره شبا" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
													<a href="#">مشاهده لیست تسویه ها</a>
												</v-col>
											</v-row>
										</div>
										<div v-if="localData.onlinePaymentGateway === 8">
											<div class="text-h6 grey--text text-right">در این روش پس از ثبت نام در سایت
												زیبال، مراحل تاییدیه
												را طی نموده و مرچنت کد از درگاه پرداخت زیبال را دریافت نمایید و در
												این بخش وارد کنید. </div>
											<v-row>
												<v-col cols="12" md="9">
													<v-text-field :disabled="localData.onlinePaymentGateway !== 8" outlined ref="merchantId" v-model="localData.zibalMerchantCode" class="left-input pt-3" label="مرچنت کد" :error-messages="errorMessages" />
												</v-col>
												<v-col cols="12" md="3" class="text-center pt-md-7">
													<a href="https://zibal.ir/ipg" target="_blank">هدایت به سایت زیبال</a>
												</v-col>
											</v-row>
										</div>
									</v-col>
								</v-row>
							</v-card>

							<v-card class="mt-6 px-3" v-if="checkActivePart('bankGatewayRouter') && localData.isOnlinePaymentActive">
								<v-row>
									<v-col cols="12" md="12" class="d-flex justify-center">
										<v-switch v-model="hasBankGatewayRouter" label="استفاده از روتر واسط درگاه بانگی" color="secondary" :value="true" hide-details></v-switch>
									</v-col>
									<v-col cols="12" md="12" v-if="hasBankGatewayRouter">
										<v-text-field outlined v-model="localData.bankGatewayRouterBaseUrl" class="left-input pt-3" label="آدرس روتر" :error-messages="errorMessages" />
									</v-col>
								</v-row>
							</v-card>

							<v-card class="px-3 mt-6">
								<v-row>
									<v-col cols="12" class="p-3">
										<v-label class="grey--text">
											در صورت تمایل می توانید اطلاعات بانکی خود را جهت واریز وجه، شامل شماره کارت
											و شماره شبا و غیره را در
											بخش زیر وارد کنید. این اطلاعات در داشبورد کاربران نمایش داده می شود.
										</v-label>
										<v-textarea class="mt-3" v-model="localData.bankInfo" outlined label="توضیحات اطلاعات بانکی خود را وارد کنید" hint="حداکثر 1000 کاراکتر" />
									</v-col>
								</v-row>
							</v-card>

							<v-card class="px-3 mt-6">
								<v-row>
									<v-col cols="12" class="p-3">
										<v-label class="grey--text">
											تنظیمات درگاه بانکی واسط صورتحساب های نمایندگان را ثبت کنید:
										</v-label>
									</v-col>
								</v-row>
								<v-row class="flex-column align-center" v-if="checkActivePart('agentFactor')">
									<v-col cols="12" md="6" class="py-0 my-0">
										<v-combobox v-model="localData.agentFactorOnlinePaymentGateway" clearable required :items="iceGateways" label="درگاه بانکی واسط" single-line return-object item-text="title" item-value="id" :error-messages="errorMessages" :rules="[(val) => !!val || 'درگاه پرداخت الزامی است']" />
									</v-col>
									<v-col cols="12" md="6" class="py-0 my-0">
										<v-text-field class="left-input" v-model="localData.agentFactorCommission" type="number" label="درصد کارمزد" :error-messages="errorMessages" :rules="[(val) => val >= 0 && val < 100 || 'درصد کارمزد صحیح نمی باشد']" />
									</v-col>
									<v-col cols="12" md="6" class="py-0 my-0">
										<v-text-money class="left-input" v-model="localData.maxAgentFactorCommission" label="حداکثر مبلغ کارمزد (به تومان)" :error-messages="errorMessages" :rules="[(val) => localData.maxAgentFactorCommission >= 0 || 'مبلغ حداکثر کارمزد صحیح نمی باشد']" />
									</v-col>
								</v-row>
							</v-card>

						</v-card>
					</v-form>
				</v-tab-item>
				<!-- <v-tab-item :key="2">
					<v-row justify="center" class="ma-0">
						<v-col cols="10">
							<v-form ref="iceForm" class="mx-2" lazy-validation>
								<v-card class="px-3 py-5 mb-3">
									<v-row>
										<v-col cols="12" md="12" class="d-flex justify-center">
											<v-switch v-model="localData.iceConfig.isIceActive" label="اعتبارسنجی آیس فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
										</v-col>
									</v-row>
									<v-row class="flex-column align-center" v-if="localData.iceConfig.isIceActive">
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.iceConfig.username" label="نام کاربری سامانه" :error-messages="errorMessages" :rules="[(val) => !localData.iceConfig.isIceActive || !!val.length || 'نام کاربری الزامی است']" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.iceConfig.password" label="کلمه عبور سامانه" :error-messages="errorMessages" :rules="[(val) => !localData.iceConfig.isIceActive || !!val.length || 'کلمه عبور الزامی است']" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-combobox v-model="localData.iceConfig.icePaymentGateway" clearable required :items="iceGateways" label="انتخاب درگاه پرداخت" single-line return-object item-text="title" item-value="id" :error-messages="errorMessages" :rules="[(val) => !localData.iceConfig.isIceActive || !!val || 'درگاه پرداخت الزامی است']" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.iceConfig.price" type="number" label="هزینه عملیات(به تومان)" :error-messages="errorMessages" :rules="[(val) => !localData.iceConfig.isIceActive || !!val.length || 'هزینه عملیات الزامی است']" />
										</v-col>
									</v-row>
								</v-card>
							</v-form>
						</v-col>
					</v-row>
				</v-tab-item> -->
				<v-tab-item :value="2" v-if="checkPermission('AppSettings_IranValidityTab')">
					<v-row justify="center" class="ma-0">
						<v-col cols="10">
							<v-form ref="iceForm" class="mx-2" lazy-validation>
								<v-card class="px-3 py-5 mb-3">
									<v-row>
										<v-col cols="12" md="12" class="d-flex justify-center">
											<v-switch v-model="localData.iranValidityConfig.isActive" label="اعتبارسنجی ایران فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
										</v-col>
									</v-row>
									<v-row class="flex-column align-center" v-if="localData.iranValidityConfig.isActive">
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.iranValidityConfig.baseUrl" label="آدرس پایه وب سرویس" :error-messages="errorMessages" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.iranValidityConfig.username" label="نام کاربری سامانه" :error-messages="errorMessages" :rules="[(val) => !localData.iranValidityConfig.isActive || !!val || 'نام کاربری الزامی است']" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.iranValidityConfig.password" label="کلمه عبور سامانه" :error-messages="errorMessages" :rules="[(val) => !localData.iranValidityConfig.isActive || !!val || 'کلمه عبور الزامی است']" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-combobox v-model="localData.iranValidityConfig.paymentGateway" clearable required :items="iceGateways" label="انتخاب درگاه پرداخت" single-line return-object item-text="title" item-value="id" :error-messages="errorMessages" :rules="[(val) => !localData.iranValidityConfig.isActive || !!val || 'درگاه پرداخت الزامی است']" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.iranValidityConfig.price" type="number" label="هزینه عملیات (به تومان)" :error-messages="errorMessages" :rules="[(val) => !localData.iranValidityConfig.isActive || !!val.length || 'هزینه عملیات الزامی است']" />
										</v-col>
									</v-row>
								</v-card>
							</v-form>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item :value="3" v-if="checkPermission('AppSettings_RefahBetaTab') && checkActivePart('refahBeta')">
					<v-row justify="center" class="ma-0">
						<v-col cols="10">
							<v-form ref="refahBetaForm" class="mx-2" lazy-validation>
								<v-card class="px-3 py-5 mb-3">
									<v-row class="flex-column align-center">
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.refahBetaConfig.clientId" label="Client-Id" :error-messages="errorMessages" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.refahBetaConfig.clientSecret" label="Client-Secret" :error-messages="errorMessages" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.refahBetaConfig.apiKey" label="Api-Key" :error-messages="errorMessages" />
										</v-col>
									</v-row>
								</v-card>
							</v-form>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item :value="4" v-if="checkPermission('AppSettings_EmzameTab') && checkActivePart('emzame')">
					<v-row justify="center" class="ma-0">
						<v-col cols="10">
							<v-form ref="refahBetaForm" class="mx-2" lazy-validation>
								<v-card class="px-3 py-5 mb-3">
									<v-row class="flex-column align-center">
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.emzameConfig.nationalCode" label="کدملی" :error-messages="errorMessages" />
										</v-col>
										<v-col cols="12" md="8" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.emzameConfig.password" label="کلمه عبور" :error-messages="errorMessages" />
										</v-col>
									</v-row>
								</v-card>
							</v-form>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item :value="5" v-if="checkPermission('AppSettings_LandingPageTab')">
					<v-row justify="center" class="ma-0">
						<v-col cols="10">
							<v-form ref="landingForm" class="mx-2" lazy-validation>
								<v-card class="px-3 py-5 mb-3">
									<v-row class="flex-column align-center">
										<v-col cols="12" md="10" class="py-0 my-0 text-center">
											<v-btn color="primary" @click="routeToLandingPage()">مشاهده صفحه اختصاصی
												شما</v-btn>
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-select class="" v-model="localData.siteTheme" :items="siteThemes" label="قالب سایت" required item-text="title" item-value="id"></v-select>
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="" v-model="localData.businessTitle" label="عنوان کسب و کار" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.phones" label="شماره تماس ها" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.agentOfficePhone" label="شماره تماس امور نمایندگان" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.email" label="ایمیل" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="" v-model="localData.address" label="آدرس" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.shopLink" label="لینک فروشگاه" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="" v-model="localData.shopTitle" label="عنوان لینک فروشگاه" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.enamadLink" label="لینک اینماد" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.etehadieLink" label="لینک اتحادیه کشوری" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.samandehiLink" label="لینک ساماندهی" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.anjomanSenfiLink" label="لینک انجمن صنفی" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.kasboKarhayeInternetiTehranLink" label="لینک انجمن صنفی کسب و کارهای اینترنتی تهران" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.applicationLink" label="لینک دانلود اپلیکیشن" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.instagramLink" label="لینک اینستاگرام" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.telegramLink" label="لینک تلگرام" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.whatsappLink" label="لینک واتساپ" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.rubikaLink" label="لینک روبیکا" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-text-field class="left-input" v-model="localData.aparatLink" label="لینک آپارات" />
										</v-col>
										<v-col cols="12" md="10" class="py-0 my-0">
											<v-select class="" v-model="localData.calculatorType" :items="calculatorTypes" label="نوع ماشین حساب" required item-text="title" item-value="id"></v-select>
										</v-col>
									</v-row>
								</v-card>
							</v-form>
						</v-col>
					</v-row>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" :loading="loading" dark @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import { call, get } from 'vuex-pathify'
import _ from 'lodash'
import router from '@/router'

export default {
	name: 'AppSettingsView',
	props: {
		data: { type: Object },
	},
	data() {
		return {
			activeTab: 0,
			errorMessages: '',
			localData: { dashboardSettings: {}, iceConfig: {}, iranValidityConfig: {}, refahBetaConfig: {} },
			show1: false,
			show2: false,
			loading: false,
			hasBankGatewayRouter: false,
			appendToWhichInstallmentItems: [{
				id: 0,
				title: 'بدون تاثیر باشد'
			},
			{
				id: 1,
				title: 'به اولین قسط اضافه شود'
			},
			{
				id: 2,
				title: 'به آخرین قسط اضافه شود'
			}],
			roundCountNumber: [{
				id: 0,
				title: '0'
			},
			{
				id: 1,
				title: '1'
			},
			{
				id: 2,
				title: '2'
			},
			{
				id: 3,
				title: '3'
			},
			{
				id: 4,
				title: '4'
			}],
			iceGateways: [
				{ id: 1, title: 'زرین پال' },
				{ id: 3, title: 'بانک سامان' },
				{ id: 4, title: 'نکست پی' },
				{ id: 5, title: 'بانک پارسیان' },
				{ id: 6, title: 'بانک ملی سداد' },
				{ id: 7, title: 'بانک صادرات سپهر' },
			],
			onlinePaymentGateways: [
				{ id: 1, title: 'درگاه پرداخت زرین پال (کارمزد 0.5 درصد از کل تراکنش تا سقف 12,000 تومان)' },
				{ id: 3, title: 'درگاه پرداخت بانک سامان' },
				{ id: 4, title: 'درگاه پرداخت نکست پی' },
				{ id: 5, title: 'درگاه پرداخت بانک پارسیان' },
				{ id: 6, title: 'درگاه پرداخت بانک ملی سداد' },
				{ id: 7, title: 'درگاه پرداخت سپهر بانک صادرات' },
				{ id: 8, title: 'درگاه پرداخت زیبال (کارمزد 1 درصد تا سقف 20,000 تومان)' },
			],
			siteThemes: [
				{ id: 0, title: 'پیش فرض' }
			],
			calculatorTypes: [
				{ id: 0, title: 'قالب پیش فرض' },
				{ id: 1, title: 'قالب خالص دریافتی (هزینه های عملیاتی و جریمه مخفی)' }
			],
		}
	},
	mounted() {
		this.prepareData()
		let permitSitesForNafisTheme = ['nafisvam', 'localhost']
		if (permitSitesForNafisTheme.some(x => window.location.hostname.indexOf(x) > -1)) {
			this.siteThemes.push({ id: 1, title: 'نفیس' })
		}
		let permitSitesForSafeGolds = ['safegolds', 'localhost']
		if (permitSitesForSafeGolds.some(x => window.location.hostname.indexOf(x) > -1)) {
			this.siteThemes.push({ id: 2, title: 'طلای سیف زاده' })
		}
	},
	computed: {
		...get('siteConfig', [
			'isCloud'
		]),
		...get('auth', [
			'getCurrentUser'
		])
	},
	methods: {
		...call('appSettings/*'),
		submit() {
			if (this.$refs.overallForm && !this.$refs.overallForm.validate()) {
				this.activeTab = 0
				return
			}
			if (this.$refs.financeForm && !this.$refs.financeForm.validate()) {
				this.activeTab = 1
				return
			}
			this.localData.isOnlinePaymentActive = !!this.localData.isOnlinePaymentActive
			this.loading = true
			var data = _.cloneDeep(this.localData)
			data.roundCountNumber = this.localData.roundCountNumber?.id
			data.appendToWhichInstallment = this.localData.appendToWhichInstallment?.id
			data.iceConfig.isIceActive = !!data.iceConfig.isIceActive
			data.iceConfig.icePaymentGateway = this.localData.iceConfig.icePaymentGateway?.id || 0
			data.iranValidityConfig.isActive = !!data.iranValidityConfig.isActive
			data.iranValidityConfig.paymentGateway = this.localData.iranValidityConfig.paymentGateway?.id || 0
			data.agentFactorOnlinePaymentGateway = this.localData.agentFactorOnlinePaymentGateway?.id || 0
			data.bankGatewayRouterBaseUrl = !this.hasBankGatewayRouter ? '' : data.bankGatewayRouterBaseUrl
			this.sync(data).then(x => {
				this.loading = false
				toast.success('اطلاعات با موفقیت ذخیره شد.')
			}).catch(err => {
				this.loading = false
				toast.error(err.message)
			})
		},
		prepareData() {
			this.fetch({ force: true }).then(x => {
				this.localData = x
				this.hasBankGatewayRouter = !!x.bankGatewayRouterBaseUrl
				this.localData.iceConfig.icePaymentGateway = this.iceGateways.find(x => x.id == this.localData.iceConfig.icePaymentGateway)
				this.localData.iranValidityConfig.paymentGateway = this.iceGateways.find(x => x.id == this.localData.iranValidityConfig.paymentGateway)
				this.localData.agentFactorOnlinePaymentGateway = this.iceGateways.find(x => x.id == this.localData.agentFactorOnlinePaymentGateway)
			})
		},
		routeToLandingPage() {
			router.push({ name: 'customerLanding/Plans', params: { customerCode: this.getCurrentUser?.userData?.customer?.code || '0' } })
		}
	},
}
</script>
<style scoped>
.sms-row {
	justify-content: center;
	align-items: center;
	border-bottom: 1px solid #d7d7d7;
}
</style>
